enum FlexGridEditTypeEnum {
    Add,
    Edit,
    Copy,
}

export default FlexGridEditTypeEnum;
